import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import uuid from "react-uuid";
import storageService from "../Services/storageService";
import { fireGtmEvent } from "../utils/googleAnalytics";

import { IMAGE_QUALITY, instaPropsArr } from "./utils";

const HotelHelmet = ({
  title,
  address,
  HotelImages,
  websiteSlug,
  domain,
  city,
  description,
  hotelId,
  state,
  HotelRooms,
  currency,
  reviews,
  logo,
  keywords,
}) => {
  let descriptions = `${title} ${address}. Free cancellation and best price guaranteed on our official website. Hotels near ${address}. Cheap stays in ${address}. hotels in ${city}`;

  const [sortedRooms, setSortedRooms] = useState([]);
  // console.log("id", hotelId);

  useEffect(() => {
    if (HotelRooms && HotelRooms?.length > 1) {
      let availRooms = HotelRooms?.filter((rm) =>
        rm?.pricing?.every((rv) => rv?.roomCount > 0)
      );

      let nonAvailRooms = HotelRooms?.filter((rm) =>
        rm?.pricing?.some((rv) => rv?.roomCount === 0)
      );

      availRooms.sort((a, b) => {
        const sumA = a?.pricing.reduce((acc, val) => acc + val?.price, 0);
        const sumB = b?.pricing.reduce((acc, val) => acc + val?.price, 0);
        return sumA - sumB;
      });

      setSortedRooms([...availRooms, ...nonAvailRooms]);
    } else {
      setSortedRooms(HotelRooms);
    }
  }, [HotelRooms]);

  let leastPrice = sortedRooms?.length > 0 ? sortedRooms[0]?.defaultPrice : 0;

  useEffect(() => {
    try {
      let userId = storageService.get("userId");
      if (!userId) {
        let temp = uuid();
        storageService.set("userId", temp);
        fireGtmEvent("user_came");
      }
    } catch (error) {}
  }, []);

  let newTitle =
    title?.length > 40
      ? title
      : city
      ? `${title} ${city} starts at ${currency} ${leastPrice}`
      : `${title} starts at ${currency} ${leastPrice}`;

  return (
    <Helmet>
      {newTitle && <title>{`${newTitle}`}</title>}
      {title && (
        <meta name="description" content={`${title} ${descriptions}`} />
      )}
      <meta name="keywords" content={keywords} />

      {logo ? (
        <link rel="apple-touch-icon" href={logo} />
      ) : (
        <link
          rel="apple-touch-icon"
          href={`https://${websiteSlug}.bookmystay.io/logo192.png`}
        />
      )}

      {logo ? (
        <link rel="icon" href={logo} />
      ) : (
        <link
          rel="icon"
          href={`https://${websiteSlug}.bookmystay.io/favicon.ico`}
        />
      )}

      {websiteSlug && (
        <link
          rel="canonical"
          href={
            domain
              ? `https://${domain}`
              : `https://${websiteSlug}.bookmystay.io`
          }
        />
      )}

      <meta property="og:title" content={title + "'s Official Website"} />
      <meta property="og:type" content={"website"} />
      <meta
        property="og:url"
        content={domain ? domain : `https://${websiteSlug}.bookmystay.io`}
      />
      {(HotelImages || logo) && (
        <meta
          property="og:image"
          content={
            logo
              ? logo
              : HotelImages[0]?.cdnImageUrl +
                `?tr=w-auto-300,ar-1-1,h-200,q-${IMAGE_QUALITY}`
          }
        />
      )}
      <meta
        property="og:description"
        content={
          "Book direct on our official website, Best service and price guaranteed"
        }
      />

      <meta property="twitter:card" content="summary" />
      <meta property="twitter:title" content={title + "'s Official Website"} />
      <meta property="twitter:type" content={"website"} />
      <meta
        property="twitter:url"
        content={domain ? domain : `https://${websiteSlug}.bookmystay.io`}
      />
      {HotelImages && (
        <meta
          property="twitter:image"
          content={
            HotelImages[0]?.cdnImageUrl +
            `?tr=w-auto-300,ar-1-1,h-200,q-${IMAGE_QUALITY}`
          }
        />
      )}

      <link
        rel="preload"
        href="https://ik.imagekit.io/hotelzifyprod/6d42c495-c5a6-4e9f-9d63-5af60ba1427e.jpg?tr=f-webp"
        as="image"
        type="image/webp"
      />

      <link
        rel="preload"
        href="https://ik.imagekit.io/hotelzifyprod/f8f53971-d248-4cc3-a971-97a811fa94a4.svg"
        as="image"
        type="image/svg"
      />

      <link
        rel="preload"
        href="https://ik.imagekit.io/hotelzifyprod/9294a55f-eb3c-48a1-8e53-c23f10fb1397.png"
        as="image"
        type="image/png"
      />

      {/* <link
        rel="preload"
        href="https://ik.imagekit.io/hotelzifyprod/0d490838-f25a-4cd3-8724-e5d07802a613.png"
        as="image"
        type="image/webp"
      /> */}

      <meta
        property="twitter:description"
        content={`Book direct on our official website, Best service and price guaranteed`}
      />

      {instaPropsArr.includes(hotelId) && (
        <script
          type="text/javascript"
          src={"https://d1qflh9ill7vje.cloudfront.net/whatmore.js"}
          defer="defer"
        ></script>
      )}
      {instaPropsArr.includes(hotelId) && (
        <link
          rel="stylesheet"
          href={"https://d1qflh9ill7vje.cloudfront.net/whatmore.css"}
          type="text/css"
          media="all"
        ></link>
      )}
    </Helmet>
  );
};

export default HotelHelmet;
